var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{attrs:{"hide-details":"","loading":_vm.loading,"inset":"","label":"Administrateur·ice de l'établissement ? "},on:{"change":_vm.envoyerChangerEstAdministrateur},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }